import React from "react";
import { Button } from "@picklebet/ui";
import * as support from "@/utilities/support";

export const DVSConsent = (
  <>
    I consent to Picklebet verifying my identity with the relevant document
    issuer, including the DVS for Australian Government IDs, in accordance with
    our{" "}
    <Button
      variant="link"
      onClick={() =>
        support.open({
          labels: ["weblink-dvs-privacy-collection-notice"],
        })
      }
    >
      DVS Privacy Collection Notice
    </Button>
    .
  </>
);
